import { gql } from '@apollo/client'

export const POST_ITEM_FIELDS = gql`
  fragment postItemFields on SquarePostInterface {
    id
    title
    content
    sameCount
    postScope
    publishTime
    visibleType
    coverImage {
      id
      imageUrl
      width: length
      height: width
    }
    imageList {
      id
      imageUrl
    }
    itemSocialInfo {
      collectsCount
      likesCount
      disLikeCount: putDownCount
      status {
        collected
        liked
        disLiked: putDown
      }
    }
    aiArtworkInfo {
      id
      prompt
      ucPrompt
      modelTheme
      model
      size
      initImageUrl
      chatGptOptimize
      styleDecorationOptions {
        key
        name
      }
      characterOptions {
        key
        name
      }
      modelFusionOptions: modelFusion {
        key
        name
        weight
      }
      width: length
      height: width
      hiddenBaseInfo
      creativityDegree
      chinesePrompt
      chinesePromptDd
      pattern
      # 预处理方式
      pretreatmentMethod
      # 预处理图
      pretreatmentImage {
        url
      }
      superType
      prefineInfo {
        strength
        multiple
      }
      samplerModelInfo {
        samplerModelName
      }
      seed
      cfg
      ensd
      clipSkip
      # 合集
      aiCollection {
        id
        opened
      }
      extend {
        originalSquarePost {
          id
          status
        }
      }
    }
  }
`

export const POST_ITEM_FIELDS_FORLIST = gql`
  fragment postItemFieldsForList on SquarePostInterface {
    id
    title
    content
    sameCount
    postScope
    publishTime
    visibleType
    coverImage {
      id
      imageUrl
      width: length
      height: width
    }
    imageList {
      id
      imageUrl
    }
    itemSocialInfo {
      collectsCount
      likesCount
      status {
        collected
        liked
      }
    }
    aiArtworkInfo {
      id
      prompt
      superType
      chatGptOptimize
    }
  }
`

export const POST_ITEM_USER = gql`
  fragment postItemUser on CopyrightBaseUserInfo {
    uid
    nickname
    avatarUrl
    social {
      followStatus
    }
    userRoleInfo {
      artist
      aiArtist
    }
  }
`

export const BASE_USER_FIELDS = gql`
  fragment baseUserFields on CopyrightBaseUserInfo {
    backgroundUrl
    avatarUrl
    nickname
    personalizedSignature
    userType # 机构 ｜ 个人
    userRoleInfo {
      artist
      aiArtist
    }
    base {
      uid
    }
    social {
      fansCount
      followCount
      likesCount
      followStatus
      uid
    }
  }
`

/** 排行榜片段 */
export const AI_CREATOR_RANK_FIELDS = gql`
  fragment aiCreatorRankFields on CopyrightUserNewInfoConnection {
    pageInfo {
      hasNextPage
    }
    edges {
      node {
        uid
        base {
          avatarUrl
          backgroundUrl
          settledCreatorDay
          nickname
          uid
          userRoleInfo {
            artist
            aiArtist
          }
        }
        social {
          fansCount
          followCount
          likesCount
          followStatus
          squareCount
        }
        artworkStatistics {
          aiSameStyleCount
          aiPictureCount
          rankChange
        }
      }
    }
  }
`
